<template>
  <div class="content">
    <h3 ref="pageHeader" class="pageHeader">在线安全课程学习</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="课程名称">
          <el-input v-model="formInline.title" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.aqxxzt" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="title" label="标题" min-width="220">
        </custom-table-column>
        <custom-table-column prop="status_desc" label="状态" width="100">
        </custom-table-column>
        <custom-table-column prop="safe_level" label="安全分类" width="100">
        </custom-table-column>
        <custom-table-column prop="depart" label="院系" min-width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" min-width="160">
        </custom-table-column>
        <custom-table-column prop="desc" label="课程描述" min-width="220">
        </custom-table-column>
        <custom-table-column label="考试有效期" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.exam_start_date && scope.row.exam_end_date">{{ scope.row.exam_start_date }} 至 {{
              scope.row.exam_end_date }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="exam_count_desc" label="当前次数/可考次数" width="150">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope" v-if="scope.row.is_edit == 1">
            <el-button v-if="scope.row.status == 3 && scope.row.is_exam == 1" @click="handleExam(scope.row)" type="text"
              size="small">考试</el-button>
            <el-button v-else-if="scope.row.status == 4 && scope.row.is_exam == 1" @click="handleExam(scope.row)"
              type="text" size="small">重新考试</el-button>
            <el-button v-else-if="scope.row.status == 4 && scope.row.is_exam == 0" @click="handleLearn(scope.row)"
              type="text" size="small">重新学习</el-button>
            <el-button v-else-if="scope.row.status == 5" @click="handleDownload(scope.row)" type="text"
              size="small">准入证书</el-button>
            <el-button v-else-if="scope.row.status == 1 || scope.row.status == 2" @click="handleLearn(scope.row)"
              type="text" size="small">学习</el-button>
            <!-- <el-button v-if="$store.state.userInfo && !$until.checkPrmissions('learnSafeCourse', 'aitest')"
              @click="handleAiTest(scope.row)" type="text" size="small">AI智能测试</el-button> -->
            <!-- <el-button  @click="handleLearn(scope.row)" type="text" size="small">学习</el-button> -->
            <!-- <el-link type="primary"  href="https://oss-resume.xixunyun.com/sxs_file/file/202505/2015/20250520151127-6941043138861600768-微信图片_20250520151103.png" target="_blank">准入证书</el-link> -->
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
      <el-dialog :close-on-click-modal="false" title="课程学习" :visible.sync="videoDialogVisible"
        :before-close="closeDialog" :width="isPdf ? '900px' : '746px'">
        <div class="video-container">
          <!-- PDF 资料:整页完整预览(无滚动条),翻页固定在顶部,进度按页保存,继续学习定位到该页 -->
          <template v-if="isPdf">
            <div style="text-align:center;margin-bottom:10px;">
              <el-button size="small" :disabled="pdfCurPage <= 1" @click="pdfPrevPage">上一页</el-button>
              <span style="margin:0 12px;">{{ pdfCurPage }} / {{ pdfTotalPages }} 页</span>
              <el-button size="small" :disabled="pdfCurPage >= pdfTotalPages" @click="pdfNextPage">下一页</el-button>
            </div>
            <div v-loading="!pdfSrc || !pdfTotalPages" style="min-height:120px;">
              <div :style="{
                width: pdfScaleW ? pdfScaleW + 'px' : '100%',
                margin: '0 auto',
                overflow: 'hidden',
                boxSizing: 'border-box'
              }">
                <pdf v-if="pdfSrc && pdfTotalPages" :key="pdfKey" :src="pdfSrc" :page="pdfCurPage"
                  @page-size="onPdfPageSize" style="display:block;width:100%;border:1px solid #ebeef5;"></pdf>
              </div>
            </div>
          </template>
          <!-- 视频资料 -->
          <template v-else>
            <video ref="videoPlayer" :src="videoUrl" controls @loadedmetadata="onLoadedMetadata"
              @timeupdate="onTimeUpdate" @ended="onEnded" @seeking="onSeeking" @pause="onPause"
              @ratechange="lockPlaybackRate" controlslist="nodownload noremoteplayback" class="video-player"></video>
            <div style="text-align: center;margin-top: 10px;">
              <el-button type="primary" v-if="isLoad" @click="setProcess">保存进度</el-button>
            </div>
          </template>
        </div>
        <span slot="footer" class="dialog-footer" v-if="isPdf">
          <div style="text-align:center;">
            <el-button type="primary" size="small" @click="setProcess">保存进度</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="课程学习" :before-close="closeChapterDialog"
        :visible.sync="detailDialogVisible" width="946px">
        <div>
          <custom-table :data="tableData1" border style="width: 100%">
            <custom-table-column fixed prop="chapter_name" label="资料名称" min-width="150">
            </custom-table-column>
            <custom-table-column prop="finished_desc" label="完成" width="160">
              <template slot-scope="scope" v-if="scope.row.progress">
                <span>{{ scope.row.progress.finished_desc }}</span>
              </template>
            </custom-table-column>
            <custom-table-column prop="total_time" label="已看时长(秒)/页数" width="140">
              <template slot-scope="scope" v-if="scope.row.progress">
                <span>{{ scope.row.progress.user_time }}</span>
              </template>
            </custom-table-column>
            <custom-table-column prop="total_time" label="资源时长(秒)/页数" width="140">
            </custom-table-column>
            <custom-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleLookVideo(scope.row)" v-if="scope.row.progress.finished != 1" type="text"
                  size="small">{{ lookBtnText(scope.row) }}</el-button>
              </template>
            </custom-table-column>
          </custom-table>
          <div class="pageLine">
            <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailDialogVisible = false">取 消</el-button>
          <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
        </span>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="考试" :visible.sync="examDialogVisible" width="1000px"
        destroy-on-close :before-close="closeExamDialog" top="4vh">
        <course-exam-page v-if="examDialogVisible" ref="courseExam" :paper-id="examPaperId" :row="examRow"
          @submit="handleExamSubmit" @previewCommitment="handlePreviewCommitment"></course-exam-page>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="AI智能测试" :visible.sync="aiDialogVisible" width="900px"
        destroy-on-close>
        <div style="height: 720px;">
          <AItest />
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="安全承诺书" :visible.sync="aqcnsDialogVisible" width="706px"
        destroy-on-close @opened="loadCommitmentFile">
        <CommitmentSign ref="sign" :signType="aqcnsParams.signType" :studentId="aqcnsParams.studentId"
          @signed="handleCommitmentSigned"></CommitmentSign>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import CourseExamPage from "./components/courseExamPage";
import CommitmentSign from "./commitmentSign.vue";
import AItest from "@/views/Ai/ai-test.vue";
import pdf from 'vue-pdf';

export default {
  name: 'trainingRoom',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
        title: '',
        status: '',
        post: 1,
      },
      examPaperId: '', // 试卷 id(取列表行 question_id,子组件按 api/new/paper/detail/{id} 拉试卷+题目)
      examRow: {}, // 当前课程行数据(question_name/exam_time 等兜底)
      formInline1: {
        course_id: '',
        post: 1,
      },
      form1: {
        user_time: 0,
        chapter_id: '',
      },
      videoDialogVisible: false,
      detailDialogVisible: false,
      examDialogVisible: false,
      aiDialogVisible: false,
      aqcnsDialogVisible:false,
      // 与 store.state.preExamOptions 中的"考试前需签署最新版本安全承诺书"取值一致
      preExamSignText: '考试前需签署最新版本安全承诺书',
      aqcnsParams:{
        signType:'view',
        studentId:'',
      },
      tableData1: [],
      total1: 0,
      total: 0,
      tableData: [],
      videoUrl: '', // 替换为实际视频路径
      currentTime: 0,
      passTime: 0,
      progress: 0,
      isLoad: false,
      isSeeking: false,
      savedTime: 0,
      src: '',
      // PDF 学习:资料为 pdf 时走 pdf 预览,进度存页数
      isPdf: false,
      pdfSrc: '',
      pdfTotalPages: 0,
      pdfCurPage: 1,
      pdfKey: 0,
      pdfSavedPage: 0,
      pdfAutoSaved: false,
      pdfRatio: 0.7071, // 页面宽高比(竖版 A4 默认,page-size 事件到后更新)
      pdfScaleW: 0, // 按可用高度计算的整页显示宽度(无滚动条)
      _pdfObjUrl: '',
    };
  },
  components: {
    CourseExamPage,
    CommitmentSign,
    AItest,
    pdf,
  },
  created() {
  },
  mounted() {

    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleAiTest() {
      this.aiDialogVisible = true
    },
    // 考试入口:先按 api/new/paper/detail/{paperId}/{courseId} 判断考试前置(安全承诺书),再打开考试弹窗
    async handleExam(row) {
      this.examPaperId = row.question_id || ''
      this.examRow = row || {}
      // 课程配置"考试前需签署最新版本安全承诺书"且学生未签署时:先签字,签完再进考试
      let needSign = false
      if (this.examPaperId) {
        try {
          let res = await this.$api.instance.interfaceServer(`api/new/paper/detail/${this.examPaperId}/${row.id}`, 'get', {}, { isLoadd: false });
          if (res.code == 0 && res.data) {
            const info = res.data.course_Info || {}
            needSign = info.pre_exam == this.preExamSignText && Number(res.data.is_sign) == 0
          }
        } catch (e) {
          // 前置校验失败不阻断考试(接口异常提示由拦截器统一给出)
        }
      }
      if (needSign) {
        this.openCommitmentDialog('sign')
        return
      }
      this.examDialogVisible = true
    },
    // 打开安全承诺书弹窗:sign 签字 / view 预览(弹窗内容 destroy-on-close,PDF 在 opened 后重新加载)
    openCommitmentDialog(signType) {
      const user = this.$store.state.userInfo || {}
      this.aqcnsParams = {
        signType: signType,
        studentId: user.id === undefined || user.id === null ? '' : String(user.id),
      }
      this.aqcnsDialogVisible = true
    },
    loadCommitmentFile() {
      if (this.$refs.sign) this.$refs.sign.getPdfFile()
    },
    // 考试信息页"安全承诺书已签,点击预览"按钮
    handlePreviewCommitment() {
      this.openCommitmentDialog('view')
    },
    // 签字保存成功:关闭签字弹窗,继续进入考试
    handleCommitmentSigned() {
      this.aqcnsDialogVisible = false
      this.examDialogVisible = true
    },
    // 交卷:api/new/paper/submit POST(组件已组装 {id, course_id, score, content})
    async handleExamSubmit(payload) {
      try {
        const res = await this.$api.instance.interfaceServer('api/new/paper/submit', 'post', payload);
        // if (res.code == 0) {
          // 交卷成功:成绩单弹窗展示 成绩(buildPayload.score)+ 结果(接口 msg);弹窗由用户关闭
          const msg = (res && res.msg) || '交卷成功'
          const page = this.$refs.courseExam
          if (page && page.setSubmittedTip) {
            page.setSubmittedTip(msg)
            if (page.showReport) {
              page.showReport(payload.score, msg)
            }
          } else {
            this.$message({
              type: 'success',
              center: true,
              message: msg,
            });
          }
        // }
        this.getList()

      } catch (e) {
        this.$message({
          type: 'error',
          center: true,
          message: '交卷失败,请关闭弹窗后重新进入考试',
        });
      }
    },
    // 考试弹窗关闭:答题中退出算作一次考试,确认后提交当前试卷
    closeExamDialog(done) {
      const page = this.$refs.courseExam
      if (page && page.getStage && page.getStage() == 'doing') {
        // 已交卷(手动/时间到/中途退出已触发提交,接口结果未回)允许直接关闭
        if (page.getSubmitted && page.getSubmitted()) {
          if (done) done()
          return
        }
        // 未交卷:确认后直接交卷(消耗一次考试机会),提交成功后提示在弹窗内展示,由用户关闭
        this.confirmBox('warning', '中途退出将算作一次考试并提交当前试卷,确定退出吗?', {}, () => {
          page.quitSubmit()
        });
      } else if (done) {
        done();
      }
    },
    handleDownload(row) {
      this.$until.downloadData(`api/new_course_chapter/downloadCertificate/${row.id}`, "post")
    },
    handleHref() {

    },
    onLoadedMetadata() {
      console.log("onLoadedMetadata")
      this.isLoad = true
      if (this.savedTime) {
        this.currentTime = parseFloat(this.savedTime);
        this.passTime = this.currentTime;
        this.$refs.videoPlayer.currentTime = this.currentTime;
      }
    },

    // 时间更新处理
    onTimeUpdate(e) {
      console.log("onTimeUpdate")
      const video = e.target;
      this.passTime = this.currentTime;
      if (!this.isSeeking) {
        this.currentTime = video.currentTime;
        // console.log(this.currentTime, video.currentTime, this.passTime)
      }
      // console.log("进度" + this.currentTime + "进度" + video.currentTime)

    },
    onSeeking(e) {
      // console.log("快进ing")
      this.isSeeking = true;
      const video = e.target;
      // 如果跳转时间大于当前已播放时间
      if (video.currentTime > this.passTime) {
        video.currentTime = this.passTime;
      }
      this.isSeeking = false;
    },
    // 禁止快进处理
    onEnded(e) {
      console.log("结束")
      // this.closeDialog()
      this.setProcess()
      this.videoDialogVisible = false
      this.getList()
    },
    // 暂停保存进度
    onPause(e) {
      console.log("暂停")
      // const video = e.target;
      // this.setProcess(this.form1)
    },
    closeDialog(done) {
      if (this.isPdf) {
        this.confirmBox('warning', `是否退出并保存学习进度`, {}, this.saveAndClose);
      } else if (this.$refs.videoPlayer && this.isLoad && this.currentTime > 0) {
        this.confirmBox('warning', `是否退出视频观看`, {}, this.saveAndClose);
      } else {
        done();
      }
    },
    closeChapterDialog(done) {
      this.getList()
      done();

    },
    saveAndClose() {
      this.videoDialogVisible = false
      this.setProcess()
    },
    async setProcess() {
      // 视频存观看秒数;PDF 存当前页数
      if (this.isPdf) {
        this.form1.user_time = this.pdfCurPage || 1
      } else {
        if (this.$refs.videoPlayer) this.$refs.videoPlayer.pause()
        this.form1.user_time = Math.floor(this.currentTime);
      }
      let res = await this.$api.instance.interfaceServer(`api/new_course_chapter/learnChapter`, 'post', this.form1);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '进度已保存！',
        });
        this.getList1()
      }
    },
    // 操作按钮名称:视频未看"观看"/已看时长>0"继续观看";PDF 未学"学习"/页数>0"继续学习"
    lookBtnText(row) {
      const isPdf = /\.pdf(\?|#|$)/i.test(row.video_url || '')
      const done = row.progress && Number(row.progress.user_time) > 0
      if (isPdf) return done ? '继续学习' : '学习'
      return done ? '继续观看' : '观看'
    },
    handleLookVideo(row) {
      const url = row.video_url || ''
      this.form1.chapter_id = row.id
      if (/\.pdf(\?|#|$)/i.test(url)) {
        this.openPdfLearn(row)
      } else {
        this.isPdf = false
        this.videoUrl = url
        this.videoDialogVisible = true
        this.savedTime = row.progress && row.progress.user_time ? row.progress.user_time : 0
      }
    },
    // PDF 学习:载入文件 -> 页数;进度行 user_time 存“页数”,继续学习定位到该页
    async openPdfLearn(row) {
      const url = row.video_url || ''
      this.isPdf = true
      this.pdfSrc = ''
      this.pdfTotalPages = 0
      this.pdfCurPage = 1
      this.pdfSavedPage = parseInt((row.progress && row.progress.user_time) || 1, 10) || 1
      this.pdfAutoSaved = false
      this.pdfRatio = 0.7071
      this.pdfScaleW = 0
      this.videoDialogVisible = true
      try {
        const resp = await fetch(url)
        if (!resp.ok) throw new Error('HTTP ' + resp.status)
        const blob = await resp.blob()
        if (this._pdfObjUrl) URL.revokeObjectURL(this._pdfObjUrl)
        this._pdfObjUrl = URL.createObjectURL(blob)
        const task = pdf.createLoadingTask(this._pdfObjUrl)
        const pdfDoc = await task.promise
        this.pdfTotalPages = pdfDoc.numPages || 1
        this.pdfCurPage = Math.min(Math.max(1, this.pdfSavedPage), this.pdfTotalPages)
        this.pdfScaleW = this.calcPdfWidth(this.pdfRatio)
        this.pdfKey++
        this.pdfSrc = this._pdfObjUrl
      } catch (e) {
        this.$message.error('PDF 加载失败，请确认文件格式')
        this.isPdf = false
        this.videoDialogVisible = false
      }
    },
    pdfPrevPage() {
      if (this.pdfCurPage > 1) this.pdfCurPage--
    },
    pdfNextPage() {
      if (this.pdfCurPage < this.pdfTotalPages) {
        this.pdfCurPage++
        // 看到最后一页自动保存一次(类似视频播放结束)
        if (this.pdfCurPage >= this.pdfTotalPages && !this.pdfAutoSaved) {
          this.pdfAutoSaved = true
          this.setProcess()
        }
      }
    },
    // pdf 渲染后回调:更新页面宽高比并重算显示宽度(整页适配,不出现滚动条)
    onPdfPageSize(width, height) {
      if (width && height) {
        this.pdfRatio = width / height
        this.pdfScaleW = this.calcPdfWidth(this.pdfRatio)
      }
    },
    // 按可用高度计算整页宽:整页完整呈现,高度不超过弹窗可用区域(底部为固定翻页条)
    calcPdfWidth(ratio) {
      const winH = (window.innerHeight || 800)
      const winW = (window.innerWidth || 1280)
      const availH = Math.max(320, winH - 240)
      const maxW = Math.min(860, winW - 80)
      const w = Math.min(maxW, availH * (ratio || 0.7071))
      return Math.max(280, Math.round(w))
    },
    // 视频禁止修改倍速:ratechange 强制回 1
    lockPlaybackRate() {
      const el = this.$refs.videoPlayer
      if (el && el.playbackRate !== 1) el.playbackRate = 1
    },
    handleLearn(row) {
      this.formInline1.course_id = row.id
      this.detailDialogVisible = true
      this.handleQuery1()

    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_course/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async getList1() {
      let params = this.$until.deleteNullPrototype(this.formInline1);
      params.page = this.$refs.pageChild1.page;
      params.size = this.$refs.pageChild1.size;
      let res = await this.$api.instance.interfaceServer('api/new_course_chapter/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.video-container {
  video {
    width: 100%;
  }
}

@media screen and (max-width: 1000px) {
  /deep/.side-panel {
    display: none;
  }

  /deep/.question-panel {
    margin-right: 0;
  }

  /deep/.course-exam-page.is-doing {
    height: auto;
  }

  /deep/.countdown-label {
    display: none;
  }
}
</style>
